package com.gastoncantera.intercom.auth

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.Flow

class AuthRepository {
    private val auth = Firebase.auth

    fun currentUserOrNull(): FirebaseUser? = auth.currentUser

    val currentUser: Flow<FirebaseUser?> = auth.authStateChanged

    suspend fun signIn(email: String, password: String) {
        auth.signInWithEmailAndPassword(email.trim(), password)
    }

    /** Sesión anónima para web (QR de portero): se necesita estar autenticado para usar Firebase. */
    suspend fun signInAnonymously() {
        auth.signInAnonymously()
    }

    /** Envía el email de Firebase para restablecer la contraseña. */
    suspend fun sendPasswordResetEmail(email: String) {
        auth.sendPasswordResetEmail(email.trim())
    }

    suspend fun signOut() {
        auth.signOut()
    }
}
